<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" custom-class="view-dialog" :before-close="handleClose" :show-close="true">
      <div slot="title">
        <div class="dialog-title" v-if="computedBackList.length > 1">
          <SvgIcon
            type="back"
            class="back-icon"
            style="width: 20px; height: 20px; cursor: pointer"
            @click.native="clickBack(computedBackList[computedBackList.length - 2])"
          />
          <div class="back-word">{{ computedBackList[computedBackList.length - 2].word }}</div>
        </div>
        <!-- 字的等级 -->
        <div class="level-line" v-if="viewDialogIsZi && ziWritingFullInfo.id">
          <div
            class="tag first-tag top-tag"
            :class="ziWritingFullInfo.levels === null ? 'noLevel' : ''"
            v-for="(item, index) in filterLevel(ziWritingFullInfo.levels)"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <!-- 词的等级 -->
        <div class="level-line" v-if="!viewDialogIsZi && wordGroupList.id">
          <div
            class="tag first-tag"
            :class="wordGroupList.levels === null ? 'noLevel' : ''"
            v-for="(item, index) in filterLevel(wordGroupList.levels)"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>

      <!-- 字的弹窗 -->
      <div class="zi-dialog" v-if="viewDialogIsZi">
        <div class="word-line">
          <div class="word">{{ ziWritingFullInfo.word }}</div>
          <div class="pinyin-box">
            <a href="#"
              ><SvgIcon
                @click.native="playVideo(ziWritingFullInfo)"
                :type="typePlayButton(ziWritingFullInfo.isPinyinPlay, ziWritingFullInfo.pinyin_num)"
                class="tabler-icon play-icon"
                style="width: 20px; height: 20px"
            /></a>
            <div class="pinyin" :class="'pinyin' + numOfPinyin(ziWritingFullInfo.pinyin_num)">
              {{ ziWritingFullInfo.pinyin_tone }}
            </div>
          </div>
          <div class="explain" :title="ziWritingFullInfo.translation">{{ ziWritingFullInfo.translation }}</div>
        </div>
        <div class="tab" style="padding-right: 12px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane name="first">
              <span slot="label">
                <SvgIcon
                  type="write-vocab-active"
                  v-if="activeTab === 1"
                  class="tabler-icon"
                  style="width: 42px; height: 44px"
                />
                <SvgIcon type="write-vocab" class="tabler-icon" v-else style="width: 42px; height: 32px" />
              </span>
            </el-tab-pane>
            <el-tab-pane name="second">
              <span slot="label">
                <SvgIcon
                  type="speak-active"
                  v-if="activeTab === 2"
                  class="tabler-icon"
                  style="width: 42px; height: 44px"
                />
                <SvgIcon type="speak" class="tabler-icon" v-else style="width: 42px; height: 32px" />
              </span>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label">
                <SvgIcon
                  type="mean-active"
                  v-if="activeTab === 3"
                  class="tabler-icon"
                  style="width: 42px; height: 44px"
                />
                <SvgIcon type="mean" class="tabler-icon" v-else style="width: 42px; height: 32px" />
              </span>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 标记 -->
        <div @click="changeMark(ziWritingFullInfo)" style="cursor: pointer" v-if="ziWritingFullInfo.id">
          <div v-if="ziWritingFullInfo.is_peg === 0" class="mark">
            <SvgIcon type="plain-unmarke" class="mark-icon" style="width: 22px; height: 22px; color: #e7e7ed" />
            <span class="mark-text">{{ $t("add_mark") }}</span>
          </div>
          <div v-else class="mark" style="background: #faae56; color: #fff">
            <SvgIcon type="mark" class="mark-icon" style="width: 22px; height: 22px" />
            <span class="mark-text">{{ $t("vocab_already_marked") }}</span>
          </div>
        </div>
        <div class="content-box">
          <!-- write -->
          <div class="write" v-show="activeTab === 1">
            <WriteDemo :ziWritingFullInfo="ziWritingFullInfo" ref="writeDemo" />
            <div class="pianpang" v-if="ziWritingFullInfo">
              <div class="title">{{ $t("vocab_side") }}</div>
              <div class="pianpang-box">
                <div
                  class="pianpang-item"
                  v-for="(item, index) in bushouArr"
                  :key="index"
                  :class="bushouActiveIndex === index ? 'bushouActive' : ''"
                  @click="clickBushou(index)"
                >
                  {{ item }}
                </div>
              </div>
            </div>
            <!-- table -->
            <div class="write-table" border="false" v-if="activeTab === 1">
              <el-table
                :data="topThreeSameBushouList"
                style="width: 100%"
                :header-row-style="setHeaderStyle"
                row-class-name="row-name"
                :row-style="{ height: '40px', cursor: 'pointer' }"
                @row-click="clickZi"
                id="write-table"
              >
                <el-table-column prop="word" :label="$t('vocabulary')" width="200">
                  <template slot-scope="scope"
                    ><span class="vocab-word"
                      >{{ scope.row.word }}
                      <span v-if="scope.row.other_speakings" class="polyphonic">{{ $t("polyphonic") }}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="pinyin_tone" :label="$t('vocab_pinyin')" width="240" style="display: flex">
                  <template slot-scope="scope">
                    <a href="#"
                      ><SvgIcon
                        :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                        @click.native.stop="playVideo(scope.row)"
                        class="tabler-icon play-icon"
                        style="margin-left: -10px; margin-right: 10px; position: relative; bottom: -0.25em"
                    /></a>
                    <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="translation" :label="$t('vocab_translate')" width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column :label="$t('level')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="level-line">
                      <div
                        class="tag first-tag"
                        :class="scope.row.levels === null ? 'noLevel' : ''"
                        v-for="(item, index) in filterLevel(scope.row.levels)"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <p slot="append" @click="clickSeeMoreBushou" class="see-more" v-show="isMoreBushou">
                  <span>{{ $t("see_more") }}</span>
                  <SvgIcon type="zhankai" class="tabler-icon" style="width: 12px; height: 12px" />
                </p>
              </el-table>
            </div>
          </div>

          <!-- speak -->
          <div class="speak" v-show="activeTab === 2">
            <!-- 同音字 -->
            <div class="title">{{ $t("same_read_word") + "（" + sameSoundInfo.count + "）" }}</div>
            <div style="display: flex" v-if="sameSoundInfo.chars">
              <div class="speak-box">
                <SvgIcon
                  @click.native="playVideo(sameSoundInfo)"
                  :type="typePlayButton(sameSoundInfo.isPinyinPlay, sameSoundInfo.pinyin_num)"
                  class="tabler-icon play-icon"
                  style="width: 24px; height: 24px"
                />
                <span
                  class="pinyin"
                  :class="'pinyin' + numOfPinyin(sameSoundInfo.pinyin_num)"
                  style="font-size: 15px"
                  >{{ sameSoundInfo.pinyin }}</span
                >
              </div>
            </div>
            <!-- table -->
            <div class="write-table speak-table" v-if="activeTab === 2">
              <el-table
                :data="topThreeSameSoundChars"
                style="width: 100%"
                :header-row-style="setHeaderStyle"
                row-class-name="row-name"
                :row-style="{ height: '40px', cursor: 'pointer' }"
                @row-click="clickZi"
              >
                <el-table-column prop="word" :label="$t('vocabulary')" width="200">
                  <template slot-scope="scope"
                    ><span class="vocab-word">{{ scope.row.word }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('vocab_pinyin')" width="240" style="display: flex">
                  <template slot="header">
                    <span style="margin-left: 22px">{{ $t("vocab_pinyin") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <a href="#"
                      ><SvgIcon
                        :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                        @click.native.stop="playVideo(scope.row)"
                        class="tabler-icon play-icon"
                        style="margin-left: -10px; margin-right: 10px; position: relative; bottom: -0.25em"
                    /></a>
                    <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="translation" :label="$t('vocab_translate')" width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" :label="$t('level')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="level-line">
                      <div
                        class="tag first-tag"
                        :class="scope.row.levels === null ? 'noLevel' : ''"
                        v-for="(item, index) in filterLevel(scope.row.levels)"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <p slot="append" @click="clickSeeMoreSameSound" class="see-more" v-if="isMoreSameSound">
                  <span>{{ $t("see_more") }}</span>
                  <SvgIcon type="zhankai" class="tabler-icon" style="width: 12px; height: 12px" />
                </p>
              </el-table>
            </div>
            <!-- 近音字 -->
            <div class="title" style="padding-top: 18px">
              {{ $t("samilar_read_word") + "（" + sameSoundInfo.samilar_count + "）" }}
            </div>
            <div class="big-speak-box">
              <div
                class="speak-box"
                :class="samilarTabActiveIndex === index ? 'active-speak-box' : ''"
                style="cursor: pointer"
                @click="clickSamilaTab(index)"
                v-for="(item, index) in ziSpeakingSamilarSoundList"
                :key="index"
              >
                <SvgIcon
                  @click.native.stop="playVideo(item)"
                  :type="typePlayButton(item.isPinyinPlay, item.pinyin_num)"
                  class="tabler-icon play-icon"
                  style="width: 24px; height: 24px"
                />
                <span :class="'pinyin' + numOfPinyin(item.pinyin_num)" class="pinyin" style="font-size: 15px">{{
                  item.pinyin
                }}</span>
              </div>
            </div>
            <!-- table -->
            <div class="write-table speak-table" v-if="activeTab === 2">
              <el-table
                :data="topThreeSamilarTableInfo"
                style="width: 100%"
                :header-row-style="setHeaderStyle"
                row-class-name="row-name"
                :row-style="{ height: '40px', cursor: 'pointer' }"
                @row-click="clickZi"
              >
                <el-table-column prop="word" :label="$t('vocabulary')" width="200">
                  <template slot-scope="scope"
                    ><span class="vocab-word">{{ scope.row.word }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('vocab_pinyin')" width="240" style="display: flex">
                  <template slot="header">
                    <span style="margin-left: 23px">{{ $t("vocab_pinyin") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <a href="#" @click.stop="playVideo(scope.row)"
                      ><SvgIcon
                        :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                        class="tabler-icon play-icon"
                        style="margin-left: -10px; margin-right: 10px; position: relative; bottom: -0.25em"
                    /></a>
                    <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="translation" :label="$t('vocab_translate')" width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" :label="$t('level')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="level-line">
                      <div
                        class="tag first-tag"
                        :class="scope.row.levels === null ? 'noLevel' : ''"
                        v-for="(item, index) in filterLevel(scope.row.levels)"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template></el-table-column
                >
                <p slot="append" @click="clickSeeMoreSamilarSound" class="see-more" v-if="isMoreSamilarSound">
                  <span>{{ $t("see_more") }}</span>
                  <SvgIcon type="zhankai" class="tabler-icon" style="width: 12px; height: 12px" />
                </p>
              </el-table>
            </div>
          </div>

          <!-- mean -->
          <div class="mean" v-show="activeTab === 3">
            <div class="instance" v-if="ziMeaningMoreSentence && ziMeaningMoreSentence.length > 0">
              <div class="title">{{ $t("instance") }}</div>
              <div class="instance-box" v-for="(item, index) in ziMeaningMoreSentence" :key="index">
                <div>
                  <div class="hanyu-box">
                    <SvgIcon
                      @click.native="playVideo(item)"
                      :type="item.isPinyinPlay === false ? 'pause' : 'play'"
                      class="play-icon"
                    />
                    <div class="hanyu" v-html="item.sentence"></div>
                  </div>
                  <div class="pinyin" v-html="item.pinyin_tone"></div>
                  <div class="english">{{ item.translation }}</div>
                </div>
              </div>
              <p slot="append" @click="clickSeeMoreSentence" class="see-more" v-show="isMoreSentence">
                <span>{{ $t("see_more") }}</span>
                <SvgIcon type="zhankai" class="tabler-icon" style="width: 12px; height: 12px" />
              </p>
            </div>
            <div class="title">{{ $t("word_team") + "（" + meaningCount + "）" }}</div>
            <!-- table -->
            <div class="write-table speak-table" style="padding-top: 6px" v-if="activeTab === 3">
              <el-table
                :data="ziMeaningList"
                style="width: 100%"
                :header-row-style="setHeaderStyle"
                row-class-name="row-name"
                :row-style="{ height: '40px', cursor: 'pointer' }"
                @row-click="clickZi"
              >
                <el-table-column prop="word" :label="$t('vocabulary')" width="200">
                  <template slot-scope="scope"><div class="vocab-word" v-html="scope.row.word"></div> </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('vocab_pinyin')" width="240" style="display: flex">
                  <template slot="header">
                    <span style="margin-left: 23px">{{ $t("vocab_pinyin") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <a href="#"
                      ><SvgIcon
                        @click.native.stop="playVideo(scope.row)"
                        :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                        class="tabler-icon play-icon"
                        style="margin-left: -10px; margin-right: 10px; position: relative; bottom: -0.25em"
                    /></a>
                    <span class="pinyin" v-html="scope.row.pinyin_tone"></span>
                  </template>
                </el-table-column>
                <el-table-column prop="translation" :label="$t('vocab_translate')" width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" :label="$t('level')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="level-line">
                      <div
                        class="tag first-tag"
                        :class="scope.row.levels === null ? 'noLevel' : ''"
                        v-for="(item, index) in filterLevel(scope.row.levels)"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template></el-table-column
                >
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!-- 词的弹窗 -->
      <div class="ci-dialog" v-if="!viewDialogIsZi && wordGroupList.id">
        <div class="word-line">
          <div class="word">{{ wordGroupList.word }}</div>
          <div class="pinyin-box">
            <a href="#"
              ><SvgIcon
                @click.native="playVideo(wordGroupList)"
                :type="wordGroupList.isPinyinPlay === false ? 'pause' : 'play'"
                class="tabler-icon play-icon"
            /></a>
            <div class="pinyin">{{ wordGroupList.pinyin_tone }}</div>
          </div>
          <div class="explain" :title="wordGroupList.translation">{{ wordGroupList.translation }}</div>
        </div>
        <!-- 标记 -->
        <div @click="changeMark(wordGroupList)" style="cursor: pointer">
          <div v-if="wordGroupList.is_peg === 0" class="mark">
            <SvgIcon type="plain-unmarke" class="mark-icon" style="width: 22px; height: 22px; color: #e7e7ed" />
            <span class="mark-text">{{ $t("add_mark") }}</span>
          </div>
          <div v-else class="mark" style="background: #faae56; color: #fff">
            <SvgIcon type="mark" class="mark-icon" style="width: 22px; height: 22px" />
            <span class="mark-text">{{ $t("vocab_already_marked") }}</span>
          </div>
        </div>
        <!-- 例句 -->
        <div class="content1">
          <div class="instance" v-if="wordGroupList.sentences && wordGroupList.sentences.length > 0">
            <div class="title">{{ $t("instance") }}</div>
            <div class="instance-box" v-for="(item, index) in wordGroupList.sentences" :key="index">
              <div>
                <div class="hanyu-box">
                  <SvgIcon
                    @click.native="playVideo(item)"
                    :type="item.isPinyinPlay === false ? 'pause' : 'play'"
                    class="play-icon"
                  />
                  <div class="hanyu" v-html="item.sentence"></div>
                </div>
                <div class="pinyin" v-html="item.pinyin_tone"></div>
                <div class="english">{{ item.translation }}</div>
              </div>
            </div>
          </div>
          <div class="include-hanzi" v-if="wordGroupList.chars && wordGroupList.chars.length > 0">
            <div class="title">{{ $t("include_num_char", { total: wordGroupList.chars.length }) }}</div>
            <!-- table -->
            <div class="write-table speak-table" style="padding-top: 6px">
              <el-table
                :data="wordGroupList.chars"
                style="width: 100%"
                :header-row-style="setHeaderStyle"
                row-class-name="row-name"
                :row-style="{ height: '40px', cursor: 'pointer' }"
                @row-click="clickZi"
              >
                <el-table-column prop="word" :label="$t('vocabulary')" width="200">
                  <template slot-scope="scope"
                    ><span class="vocab-word">{{ scope.row.word }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('vocab_pinyin')" width="240" style="display: flex">
                  <template slot="header">
                    <span style="margin-left: 32px">{{ $t("vocab_pinyin") }}</span>
                  </template>
                  <template slot-scope="scope">
                    <a href="#"
                      ><SvgIcon
                        @click.native.stop="playVideo(scope.row)"
                        :type="scope.row.isPinyinPlay === false ? 'pause' : 'play'"
                        class="tabler-icon play-icon"
                        style="margin-right: 10px; position: relative; bottom: -0.25em"
                    /></a>
                    <span class="pinyin">{{ scope.row.pinyin_tone }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="translation" :label="$t('vocab_translate')" width="300" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="name" :label="$t('level')" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div class="level-line">
                      <div
                        class="tag first-tag"
                        :class="scope.row.levels === null ? 'noLevel' : ''"
                        v-for="(item, index) in filterLevel(scope.row.levels)"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
import { apiRequest } from "@/serves/http";
import ApiPath from "@/serves/path";
import WriteDemo from "@/components/vocabulary/writeDemo.vue";
export default {
  components: {
    SvgIcon,
    WriteDemo,
  },
  props: {
    //弹窗是否展示
    viewDialogVisible: {
      type: Boolean,
      default: false,
    },
    //字还是词
    isZi: {
      type: Boolean,
      default: true,
    },
    //返回的队列
    backList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //字writing页全部信息
    ziWritingFullInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //字writing页同部首字
    ziWritingSameRadicalList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //字speaking同音
    ziSpeakingSameSoundList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //字speaking相似音
    ziSpeakingSamilarSoundList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //字meaning
    ziMeaningList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 字例句
    ziMeaningSentence: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // meaning个数
    meaningCount: {
      type: Number,
      default: 0,
    },
    //词组List
    wordGroupList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      viewDialogIsZi: true,
      activeName: "first", //初始化选中的tab
      // 字中write/speak/mean切换
      activeTab: 1,
      isMark: false,
      bushouArr: [], //部首数组
      bushouActiveIndex: 0,
      sameBushouList: [], //同部首字的数组
      topThreeSameBushouList: [], //同部首字的数组的前三个
      isMoreBushou: false, //同部首是否点击了加载更多
      isMoreSameSound: false, //同音字是否点击了加载更多
      isMoreSamilarSound: false, //近音字是否点击了加载更多
      isMoreSentence: false, // 例句是否点击加载更多
      // ziMeaningMoreSentence: [], // 加载的例句数据
      samilarList: [],
      samilarTabActiveIndex: 0, //相似音active的项
      samilarTableInfo: [],
      sameSoundInfo: {}, //字speaking同音
      topThreeSameSoundChars: [], //同音数组前三个
      topThreeSamilarTableInfo: [], //近音数组前三个
      ziMeaningCount: 0,
    };
  },
  computed: {
    computedBackList() {
      return this.backList ? this.backList : [];
    },
    computedSamilarTabRelated() {
      return { ...this.ziSpeakingSamilarSoundList, samilarTabActiveIndex: this.samilarTabActiveIndex };
    },
    ziMeaningMoreSentence() {
      let showSentenceList = [];
      if (this.isMoreSentence) {
        showSentenceList = this.ziMeaningSentence.slice(0, 3);
      } else {
        showSentenceList = this.ziMeaningSentence;
      }
      return showSentenceList;
    },
  },
  watch: {
    viewDialogVisible: {
      handler(newVal) {
        this.dialogVisible = newVal;
      },
      immediate: true,
    },
    isZi: {
      handler(newVal) {
        this.viewDialogIsZi = newVal;
      },
    },
    ziMeaningSentence: {
      handler(val) {
        if (val?.length > 3) {
          this.isMoreSentence = true;
        } else {
          this.isMoreSentence = false;
        }
      },
      immediate: true,
    },
    //字writing里同部首的数据
    ziWritingSameRadicalList: {
      handler(newVal) {
        this.bushouArr = [];
        this.sameBushouList = [];
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            this.bushouArr.push(item.radical);
          });
          this.sameBushouList = newVal[0].radical_chars;
        }
        console.log(this.bushouArr);
      },
    },
    //监听同部首数组取前三个
    sameBushouList: {
      handler(newVal) {
        let radicalList;
        if (newVal && newVal.length > 3) {
          radicalList = newVal.slice(0, 3);
          this.isMoreBushou = true;
        } else {
          radicalList = newVal;
          this.isMoreBushou = false;
        }
        let finallyList = [];
        let j = 0;
        for (let index = 0; index < radicalList.length; index++) {
          const element = radicalList[index];
          if (element?.other_speakings) {
            finallyList[j] = { ...radicalList[index], dyCharacterNum: element?.other_speakings.length };
            for (let k = 0; k < element?.other_speakings.length; k++) {
              finallyList[j + 1] = { ...element?.other_speakings[k], isPinyinPlay: false, word: "" };
              j++;
            }
            j++;
          } else {
            finallyList[j] = radicalList[index];
            j++;
          }
        }
        this.$nextTick(() => {
          for (let i = 0; i < finallyList.length; i++) {
            if (finallyList[i]?.dyCharacterNum) {
              for (let j = i; j < i + finallyList[i]?.dyCharacterNum; j++) {
                //  这里包含表头
                let tdList = document.querySelectorAll("#write-table table tr")[j + 1].querySelectorAll("td");
                tdList.forEach((k) => (k.style.borderBottom = "none"));
              }
              i = i + finallyList[i]?.dyCharacterNum;
            }
          }
        });
        this.topThreeSameBushouList = finallyList;
        console.log("this.topThreeSameBushouList", this.topThreeSameBushouList);
      },
    },
    //近音字
    computedSamilarTabRelated: {
      handler() {
        this.samilarTableInfo = [];
        this.topThreeSamilarTableInfo = [];
        if (this.ziSpeakingSamilarSoundList.length > 0) {
          this.samilarTableInfo = this.ziSpeakingSamilarSoundList[this.samilarTabActiveIndex].chars;
          if (this.samilarTableInfo && this.samilarTableInfo.length > 3) {
            this.topThreeSamilarTableInfo = this.samilarTableInfo.slice(0, 3);
            this.isMoreSamilarSound = true;
          } else {
            this.topThreeSamilarTableInfo = this.samilarTableInfo;
            this.isMoreSamilarSound = false;
          }
        }
      },
    },
    //监听传递过来的同音字信息,并取得chars的前三
    ziSpeakingSameSoundList: {
      handler(newVal) {
        this.sameSoundInfo = newVal;
        if (newVal.chars && newVal.chars.length > 3) {
          this.topThreeSameSoundChars = newVal.chars.slice(0, 3);
          this.isMoreSameSound = true;
        } else {
          this.topThreeSameSoundChars = newVal.chars;
          this.isMoreSameSound = false;
        }
        console.log(this.sameSoundInfo);
      },
    },

    //meaningCount
    meaningCount: {
      handler(newVal) {
        this.ziMeaningCount = newVal;
      },
    },
  },
  methods: {
    setHeaderStyle() {
      return { "font-size": "12px", "line-height": "10px", background: "red", padding: "0px", height: "40px" };
    },
    //取pinyin_num的数字
    numOfPinyin(pinyin_num) {
      if (pinyin_num && isNaN(Number(pinyin_num[pinyin_num.length - 1])) == false) {
        return pinyin_num[pinyin_num.length - 1];
      } else {
        return "";
      }
    },
    //buttonType不同颜色
    typePlayButton(isPinyinPlay, pinyin_num) {
      return isPinyinPlay === false
        ? "voicePause" + this.numOfPinyin(pinyin_num)
        : "voicePlay" + this.numOfPinyin(pinyin_num);
    },
    // 点击切换tab（writing,speaking,meaning)
    handleClick(tab) {
      document.getElementsByClassName("content-box")[0].scrollTop = 0;
      if (tab.index === "0") {
        this.activeTab = 1;
        //点到后两个tab的时候暂停播放，回来再继续播
        if (this.$refs.writeDemo.writer) {
          this.$refs.writeDemo.writer.resumeAnimation();
        }
      } else if (tab.index === "1") {
        this.activeTab = 2;
        if (this.$refs.writeDemo.writer) {
          this.$refs.writeDemo.writer.pauseAnimation();
        }
      } else if (tab.index === "2") {
        this.activeTab = 3;
        if (this.$refs.writeDemo.writer) {
          this.$refs.writeDemo.writer.pauseAnimation();
        }
      }
    },
    //speak 切换拼音tab
    clickSamilaTab(index) {
      this.samilarTabActiveIndex = index;
    },
    // 字，词切换标记状态
    changeMark({ id, is_peg, word, pinyin_num }) {
      const params = { id };
      if (is_peg === 0) {
        apiRequest.post(ApiPath.peg_word, { id, is_peg: 1 }).then((res) => {
          console.log(res);
          if (word.length > 1) {
            this.$emit("getWordGroupDetail", params);
          } else {
            this.$emit("getWordDetailWriting", { ...params, word, pinyin_num });
          }
          console.log("请求列表了");
          this.$emit("getWordsList");
        });
      } else if (is_peg === 1) {
        apiRequest.post(ApiPath.peg_word, { id, is_peg: 0 }).then((res) => {
          console.log(res);
          if (word.length > 1) {
            this.$emit("getWordGroupDetail", params);
          } else {
            this.$emit("getWordDetailWriting", { ...params, word, pinyin_num });
          }
          this.$emit("getWordsList");
        });
      }
    },

    // tab回到初始状态，展示第一页
    tabInit() {
      this.activeTab = 1;
      this.samilarTabActiveIndex = 0;
      this.bushouActiveIndex = 0;
    },
    // 点击字查看某个字的详情
    clickZi(row) {
      this.$emit("clickViewToDetail", row.id, row.word, row.pinyin_num);
      setTimeout(() => {
        this.tabInit();
      }, 700);
    },
    //点击back
    clickBack(row) {
      console.log(row, 111);
      this.$emit("clickBackToDetail", row.id, row.word, row.pinyin_num);
      setTimeout(() => {
        this.tabInit();
      }, 700);
    },
    //格式化level信息
    filterLevel(arr) {
      if (arr === null) {
        return ["Other"];
      } else if (arr && arr.length > 0) {
        return arr.map((item) => {
          return item.level_name;
        });
      }
    },
    //播放音频
    playVideo(row) {
      this.$emit("handlePlay", row);
    },
    // 字write
    // 点击部首
    clickBushou(index) {
      this.bushouActiveIndex = index;
      this.sameBushouList = this.ziWritingSameRadicalList[index].radical_chars;
      console.log(this.sameBushouList);
    },
    // 同部首点击查看更多
    clickSeeMoreBushou() {
      console.log("点击查看更多");
      // 解构合并多音字
      let radicalList = JSON.parse(JSON.stringify(this.sameBushouList));
      let finallyList = [];
      let j = 0;
      for (let index = 0; index < radicalList.length; index++) {
        const element = radicalList[index];
        if (element?.other_speakings) {
          finallyList[j] = { ...radicalList[index], dyCharacterNum: element?.other_speakings.length };
          for (let k = 0; k < element?.other_speakings.length; k++) {
            finallyList[j + 1] = { ...element?.other_speakings[k], isPinyinPlay: false, word: "" };
            j++;
          }
          j++;
        } else {
          finallyList[j] = radicalList[index];
          j++;
        }
      }

      this.topThreeSameBushouList = finallyList;
      this.$nextTick(() => {
        for (let i = 0; i < finallyList.length; i++) {
          if (finallyList[i]?.dyCharacterNum) {
            for (let j = i; j < i + finallyList[i]?.dyCharacterNum; j++) {
              //  这里包含表头
              let tdList = document.querySelectorAll("#write-table table tr")[j + 1].querySelectorAll("td");
              tdList.forEach((k) => (k.style.borderBottom = "none"));
            }
            i = i + finallyList[i]?.dyCharacterNum;
          }
        }
      });
      console.log("this.topThreeSameBushouList111", this.topThreeSameBushouList);

      this.isMoreBushou = false;
    },
    //同音字点击查看更多
    clickSeeMoreSameSound() {
      this.topThreeSameSoundChars = this.sameSoundInfo.chars;
      this.isMoreSameSound = false;
    },
    //近音字点击查看更多
    clickSeeMoreSamilarSound() {
      this.topThreeSamilarTableInfo = this.samilarTableInfo;
      this.isMoreSamilarSound = false;
    },
    // 点击查看更多
    clickSeeMoreSentence() {
      this.isMoreSentence = false;
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("close");
      this.tabInit();
    },
    // 合并多音字列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row?.dyCharacterNum) {
          return {
            rowspan: row?.dyCharacterNum + 1,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1,
          };
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 查看弹窗
::v-deep .view-dialog {
  width: 1000px;
  height: 626px;
  border-radius: 12px;
  padding:15px;
  .el-dialog__header {
    position: relative;
    .dialog-title {
      display: flex;
      font-size: 14px;
      line-height: 20px;
      margin: -12px 0 10px 10px;
      .back-word {
        margin-top: 2px;
      }
    }
    .level-line {
      display: flex;
      margin-top: -14px;
      height: 20px;
      .tag {
        margin-top: 18px;
        width: 56px;
        height: 20px;
        background: #fafafb;
        border-radius: 4px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        display: inline-block;
        margin-right: 12px;
        &.noLevel {
          color: #b5b5be;
        }
      }
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 9px;
      right: 10px;
    }
  }
  .el-dialog__body {
    margin-bottom: 20px;
    padding-top: 0;
    padding: 10px 12px 0 24px;
    position: relative;
    .level-line {
      display: flex;
      .tag {
        width: 56px;
        height: 20px;
        background: #fafafb;
        border-radius: 4px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        display: inline-block;
        margin-right: 12px;
        &.noLevel {
          color: #b5b5be;
        }
      }
    }

    .word-line {
      display: flex;
      margin-top: 20px;
      line-height: 40px;

      .word {
        font-size: 40px;
        font-weight: 500;
      }
      .pinyin-box {
        margin-left: 33px;
        display: flex;
        font-size: 18px;
        margin-bottom: 14px;
        .tabler-icon {
          margin-top: 10px;
          margin-right: 8px;
        }
        .pinyin {
          background-color: white;
        }
      }
      .explain {
        margin-left: 36px;
        font-size: 18px;
        width: 450px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: Inter;
      }
    }

    .el-tabs__header {
      margin-bottom: 0;
      .el-tabs__nav-scroll {
        margin-bottom: -7px;
        .el-tabs__item {
          padding: 0 16px 0;
          &#tab-first {
            padding-left: 0 !important;
          }
        }
      }
    }
    .vocab-word {
      font-weight: 600;
      color: #2c2f46;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      .polyphonic {
        display: inline-block;
        min-width: 37px;
        min-height: 14px;
        padding: 0 4px;
        background: rgba(249, 175, 86, 0.2);
        border-radius: 4px;
        color: #faae56;
        font-weight: 400;
        font-size: 10px;
      }
    }
    .content-box {
      width: 962px;
      height: 418px;
      overflow-y: auto;
      margin-top: 16px;
      .write {
        .pianpang {
          margin-top: 20px;
          .title {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            font-weight: 500;
          }
          .pianpang-box {
            display: flex;
            margin-top: 12px;
            .pianpang-item {
              width: 36px;
              height: 36px;
              border: 1px solid #e7e7ed;
              border-radius: 4px;
              font-family: "KaiTi";
              margin-right: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 24px;
              line-height: 36px;
              cursor: pointer;
              &.bushouActive {
                border: 2px solid #2c2f46;
              }
            }
          }
        }
      }
      .see-more {
        font-size: 14px;
        text-align: center;
        line-height: 40px;

        span {
          padding-right: 8px;
          cursor: pointer;
        }

        .tabler-icon {
          position: relative;
          bottom: -0.1em;
          cursor: pointer;
        }
      }
      .speak {
        .title {
          font-size: 14px;
          line-height: 20px;
          font-weight: 500;
          margin-bottom: 12px;
        }
        .big-speak-box {
          display: flex;
        }
        .speak-box {
          padding-right: 8px;
          padding-left: 8px;
          margin-right: 20px;
          min-width: 60px;
          height: 32px;
          border: 1px solid #e7e7ed;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .tabler-icon {
            cursor: pointer;
            padding-right: 4px;
          }
          &.active-speak-box {
            border: 2px solid #2c2f46;
          }
        }
      }
    }
  }
}
::v-deep th {
  padding: 5px 0 3px 0 !important;
}
::v-deep td {
  padding: 5px 0 3px 0 !important;
  font-size: 16px !important;
}
::v-deep .write-table td {
  color: #2c2f46 !important;
}
::v-deep .speak-table {
  margin-right: 10px;
  .el-table {
    &::before {
      height: 0;
    }
    th.is-leaf {
      border: none;
    }
    .el-table__body-wrapper {
      border: 1px solid #ebeef5;
      border-radius: 12px;
    }
  }
}
.mark {
  min-width: 126px;
  height: 44px;
  background: #e7e7ed;
  border-radius: 6px;
  border-radius: 6px;
  position: absolute;
  top: 34px;
  right: 24px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  .mark-icon {
    position: relative;
    cursor: pointer;
  }
  .mark-text {
    font-size: 16px;
  }
}
::v-deep .el-tabs__nav-wrap::after {
  height: 1px !important;
}
::v-deep .el-table .cell.el-tooltip {
  width: 218px !important;
}
.content1 {
  overflow: auto;
  height: 460px;
  .instance {
    margin-top: 20px;
    .instance-box {
      padding: 12px 0;
      width: 100%;

      // border-bottom: 1px solid #efeff1;
      .title {
        font-weight: 500;
        font-size: 14px;
      }
      .hanyu-box {
        display: flex;
        font-size: 17px;
        line-height: 26px;
        .hanyu {
          padding-left: 12px;
          max-width: 900px;
        }
      }
      .pinyin {
        padding-left: 32px;
        font-size: 12px;
        line-height: 20px;
        color: #b5b5be;
      }
      .english {
        padding-left: 32px;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .include-hanzi {
    margin-top: 24px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
}
.mean {
  @extend .content1;
  overflow: hidden !important;
  height: auto !important;
  .instance {
    margin-top: 0 !important;
    .title {
      margin-top: 0 !important;
    }
    .instance-box {
      &:not(:last-of-type) {
        border-bottom: 1px solid #efeff1;
      }
    }
  }
  .title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    margin-top: 30px;
  }
}
.play-icon {
  width: 21px;
  height: 21px;
  cursor: pointer;
}

.pinyin1 {
  color: #ff858c !important;
}
.pinyin2 {
  color: #fac856 !important;
}
.pinyin3 {
  color: #62c1a5 !important;
}
.pinyin4 {
  color: #6ab9d2 !important;
}
.pinyin5 {
  color: #838399 !important;
}
[dir="rtl"] .mark {
  left: 24px;
  right: unset!important;
}

[dir="rtl"] .el-dialog__body {
  .word-line {
    .word {
      direction: ltr!important;
    }
    .pinyin-box {
      direction: ltr!important;
      margin-right: 33px!important;
      .tabler-icon{
        margin-left:-14px!important;
      }
    }
  }
}

</style>
